import type { GetStaticPaths, GetStaticProps, NextPage } from "next";
import React, { useEffect } from "react";
import ErrorComponent from "../../components/ErrorComponent";
import { MetaTagsComp } from "../../components/MetaTagsComp";
import BlogDetailPage from "../../components/BlogDetailPage";
import fetchUtil from "../../utils/fetchUtil";
import { CACHE_REVALIDATE, commonJotformScript } from "../../utils/constants";
import { extractIntroParagraphs } from "../../utils/helpers";

const NewsAndPressDetail: NextPage = (props: any) => {
  if (!props.pageData || props.pageData.length === 0) {
    return <ErrorComponent />;
  }
  const { meta } = props.pageData[0];
  useEffect(() => {
    const customStyle = document.documentElement.style;
    customStyle.setProperty("--navbar-color", "#6C48F0");
    customStyle.setProperty("--navbar-menu-color", "#ffff");
  }, []);

  const updatedMeta = meta?.jotforms?.length === 0 ? { ...meta, jotforms: commonJotformScript } : { ...meta };

  return (
    <>
      {updatedMeta && props.pageData?.length > 0 && <MetaTagsComp {...updatedMeta} />}
      <BlogDetailPage {...props} category="news" />
    </>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  return { paths: [], fallback: "blocking" };
};

export const getStaticProps: GetStaticProps = async (context) => {
  try {
    const pageData: any = await fetchUtil(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/blogs?slug=${context.params?.slug}&stu_dest_categories.category=News`,
      "GET",
      {},
      "",
      false
    );

    // News genuinely not found: return a real 404 instead of caching a 200
    // "error" page, which would never self-heal. A 404 is re-checked each revalidate window.
    if (!pageData?.[0]) {
      return { notFound: true, revalidate: 60 };
    }

    const { description, intro } = extractIntroParagraphs(
      pageData[0].description || "",
      2
    );
    pageData[0].description = description;
    pageData[0].intro = intro;

    return {
      props: {
        pageData,
      },
      revalidate: CACHE_REVALIDATE,
    };
  } catch (err) {
    // Transient fetch failure (CMS down/blip): short revalidate so a real page
    // recovers within ~1 min instead of being frozen for the full window.
    return { notFound: true, revalidate: 60 };
  }
};

export default NewsAndPressDetail;
